module.exports = __webpack_public_path__ + "img/lab_pic.ca5b9706.jpg";